<script setup lang="ts">
import { onMounted, ref } from "vue";
import { FormDefinition, FormResponseDto, Workflow } from "~/api";
import { applicationRouteMap } from "~/router/mainRouter";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { drawerWidth } from "~/utils/constants";
import FormResponseTemplate from "../pages/FormResponseTemplate.vue";

const props = defineProps<{
  formDefinition: FormDefinition;
  incomingFormResponseDto: FormResponseDto;
  formDrawerOpen: boolean;
  workflow?: Workflow;
  /** Answers from all forms that are marked for sharing */
  sharedAnswers?: Record<string, string>;
}>();

const emit = defineEmits<{
  (e: "closeFormDrawer"): void;
}>();

const myInfoStore = useMyInfoStore();

const formResponse = ref<FormResponseDto>();
const form = ref<FormDefinition>();

onMounted(async () => {
  await Promise.all([myInfoStore.load()]);

  formResponse.value = props.incomingFormResponseDto;
  form.value = props.formDefinition;
});

const handleClose = () => {
  emit("closeFormDrawer");
};

const navigateToPDFViewer = () => {
  if (props.workflow?.guid) {
    window.open(
      // this needs to be removed or moved to the new Action button
      "#" +
        applicationRouteMap.Compliance.children.TechSupport.children.FormPDFViewer.path
          .replace(":workflowGuid", props.workflow.guid)
          .replace("/:pdfCode?", ""),
      "_blank",
    );
  }
};
</script>
<template>
  <el-drawer
    v-if="form && formResponse"
    class="workflowResponseFormViewer"
    :model-value="formDrawerOpen"
    :destroy-on-close="true"
    :title="formResponse?.name || form?.name || 'Form'"
    direction="rtl"
    :size="drawerWidth"
    @closed="handleClose"
  >
    <template #header="{ titleId, titleClass }">
      <h3 :id="titleId" :class="titleClass">
        {{ formResponse?.name || form?.name || "Form" }}
      </h3>
    </template>
    <div v-if="form" class="formContainer">
      <div class="form-actions">
        <el-button
          v-if="workflow?.guid"
          type="primary"
          @click="navigateToPDFViewer"
        >
          View in Raw PDF Maker
        </el-button>
      </div>
      <FormResponseTemplate
        :form-guid="formDefinition.guid"
        :response-guid="incomingFormResponseDto.guid"
        :workflow="workflow"
        :shared-answers="sharedAnswers"
      >
      </FormResponseTemplate>
    </div>
  </el-drawer>
</template>
<style lang="less">
.workflowResponseFormViewer {
  .el-drawer__body {
    padding-top: 0;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
  }
}
</style>
